<template>
  <a-layout class="individual-layout">
    <IndividualInfoHeader />
    <IndividualInfoTitle />
    <ProvisioningTitle :style="{'top': '47px'}">
      <template #subTitle>
        <p class="sub_title_width individual_sub_title_container">
          下方為您的開通資訊：
        </p>
      </template>
    </ProvisioningTitle>
    <ProvisioningResult @responseStatus="getResponseMsg" :style="{'position': 'relative','top': '47px'}"/>
    <IndividualDeviceInfoButton />
    <ModalApiResultMsg
    :visible="responseMsgObj.visible"
    :title="responseMsgObj.title"
    :okText="responseMsgObj.okText"
    :cancelText="responseMsgObj.cancelText"
    :msgClass="responseMsgObj.msgClass"
    :okCallback="responseMsgObj.msgClass === 'msg_error_modal' ? callPhoneNumber : hideModal"
    :cancelCallback="redirectToAgreePage">
    <p>{{responseMsgObj.detailText}}</p>
    </ModalApiResultMsg>
  </a-layout>
</template>

<script>
    import IndividualInfoHeader from "../../components/individualInfo/IndividualInfoHeader.vue";
    import IndividualInfoTitle from "../../components/individualInfo/IndividualInfoTitle.vue";
    import ProvisioningTitle from "../../components/deviceProvision/ProvisioningTitle.vue";
    import ProvisioningResult from "../../components/deviceProvision/ProvisioningResult.vue";
    import IndividualDeviceInfoButton from "../../components/individualInfo/IndividualDeviceInfoButton.vue";
    import ModalApiResultMsg from "../../components/modal/ModalApiResultMsg.vue";
    import { mixinModalMethods } from "../../utils/mixins";
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'IndividualDeviceInfoContainer',
        components: {
            IndividualInfoHeader,
            IndividualInfoTitle,
            ProvisioningTitle,
            ProvisioningResult,
            IndividualDeviceInfoButton,
            ModalApiResultMsg,
        },
        mixins: [ mixinModalMethods ],
        data() {
          return {
            timer: null,
          }
        },
        mounted() {
          const params = {
            encodedImei: this.deviceUid,
          };

          this.getDeviceInfo(params);
        },
        methods: {
          ...mapActions('identidyOpenResult', ['identidyResultAction']),
          async getDeviceInfo(params) {
            try {
                const result = await this.identidyResultAction(params);

                if (result.opened === 0) {
                  this.timer = setTimeout(() => {
                    this.$router.push('/provisioning/step1');
                  }, 500)
                }
            } catch (error) {
              this.responseMsgObj = {
                  ...this.responseMsgObj,
                  visible: true,
                  title: '裝置不存在2',
                  okText: '撥打電話',
                  cancelText: '否',
                  detailText: '查無此裝置資訊，請聯繫客服人員',
                  msgClass: 'msg_error_modal',
              };
            }
          },
          redirectToAgreePage() {
            this.hideModal();
            this.$router.push('/provisioning/step1');
          },
        },
        computed: {
          ...mapState('identidyOpenStatus', ['deviceUid']),
        },
        beforeDestroy() {
          clearTimeout(this.timer);
        },
    }
</script>

